/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ShipIcon = ({ width = 24, height = 24, hidden = false, title = 'Ship' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m32 18-.047-13.004a1 1 0 0 0-1-.996H22V1a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v3H5a1 1 0 0 0-1 1v13l13.973-2.994ZM8 8h20v2H8ZM35.217 21.826 18 18l2 18h9.044a.989.989 0 0 0 1-.848C30.585 30.106 36 30.962 36 26v-3.198a1 1 0 0 0-.783-.976ZM0 22.802V26c0 4.962 5.415 4.106 5.956 9.152a.989.989 0 0 0 1 .848H18V18L.783 21.826a1 1 0 0 0-.783.976Z"
    />
  </svg>`;
};
